require('./bootstrap');
require('../../node_modules/bootstrap/dist/js/bootstrap');

// Register $ global var for jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;
require('jquery-mask-plugin');
